module.exports = "/_next/static/images/document-baa3d9ee3288a26dbd8067a943e15cc2.svg";